import Image from 'next/image';
import { FC } from 'react';

type Props = {
	src: string;
	alt?: string;
};

export const HeroImage: FC<Props> = ({ src, alt = '' }) => {
	return (
		<div className="py-8 flex justify-center">
			<Image src={src} width={96} height={96} alt={alt} />
		</div>
	);
};
